import React from 'react';
import Table from '../../../common/table/Table';
import Const from './Const';
import { omit, includes } from 'lodash';
import { getColorPrice } from '../../../helpers/Color';
import { getDataFollowKeyByDot } from '../../../helpers/Common';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
  formatValue,
} from '../../../helpers/Text';
import TradingViewUrl from '../../../common/TradingViewUrl';

import { groupBy } from '../../../helpers/ArrayUtils';
import { getListIdAndListObjById } from '../../../helpers/Api';
import TimeZoneHandle from '../../../common/timezone-handle';

export default TablePutThrough;

function TablePutThrough(props) {
  const { name, realTimeData, data } = props;

  const groupByTicker = groupBy('ticker');
  const listGroupedData = groupByTicker(data);
  const listTicker = Object.keys(listGroupedData);

  const listNewDataPushToTable = [];

  if (realTimeData && realTimeData.length) {
    realTimeData.forEach(item => {
      const {
        totalDealVolume,
        totalDealValue,
        ticker,
        matchPrice,
        tradingDate,
      } = item;
      const isTickerExitInTable = listTicker.includes(ticker);
      if (isTickerExitInTable) {
        const lastTickerInTable = listGroupedData[ticker][0];
        if (totalDealVolume > lastTickerInTable.totalDealVolume) {
          const dealVolume =
            totalDealVolume - lastTickerInTable.totalDealVolume;
          const dealValue = totalDealValue - lastTickerInTable.totalDealValue;
          const dealPrice = matchPrice;
          const newRow = {
            ticker,
            dealVolume,
            dealValue,
            dealPrice,
            totalDealValue,
            tradingDate,
          };
          listNewDataPushToTable.push(newRow);
        }
      }
    });
  }
  const combineData = [...listNewDataPushToTable, ...data];
  const { listId, listObjById } = getListIdAndListObjById(combineData);

  return (
    <div className="d-flex flex-fill flex-column h-100">
      <Table
        isParentFullHeight={false}
        ids={listId}
        resizable={true}
        columnDraggable={true}
        rowDraggable={false}
        multiHead={{ name }}
        getDataFromRedux={() => listObjById}
        schema={Object.keys(
          omit(Const.putThrough, Const.listIgnoreColumnPutThrough),
        ).map((item, index) => {
          const key = Const.putThrough[item];
          const title = `watchListSummary.listTitlePutThroughMatchedTable.${item}`;
          const result = {
            key,
            title,
          };

          if (index === 0) {
            return {
              ...result,
              isString: true,
              thStyle: { textAlign: 'left' },
              render: (text, item) => (
                <>
                  <TradingViewUrl
                    code={getDataFollowKeyByDot(
                      item,
                      Const.putThrough.ORGAN_CODE,
                    )}
                  />
                  &nbsp;{text}
                </>
              ),
            };
          }
          if (includes([Const.putThrough.DEAL_PRICE], key)) {
            return {
              ...result,
              thStyle: { textAlign: 'right' },
              render: (text, item) => {
                const className = getColorPrice(
                  text,
                  getDataFollowKeyByDot(item, Const.putThrough.REFERENCE_PRICE),
                );
                return (
                  <span className={className}>
                    {formatTextFloat(formatPrice(text))}
                  </span>
                );
              },
            };
          }

          if (includes([Const.putThrough.DEAL_VOLUME], key)) {
            return {
              ...result,
              thStyle: { textAlign: 'right' },
              render: text => (
                <span>{formatTextFloat(formatVolume(text))}</span>
              ),
            };
          }

          if (
            includes(
              [Const.putThrough.DEAL_VALUE, Const.putThrough.TOTAL_DEAL_VALUE],
              key,
            )
          ) {
            return {
              ...result,
              thStyle: { textAlign: 'right' },
              render: text => <span>{formatTextFloat(formatValue(text))}</span>,
            };
          }

          if (key === Const.putThrough.TRADING_DATE) {
            return {
              ...result,
              thStyle: { textAlign: 'left' },
              render: text => (
                <div className="text-left">
                  <TimeZoneHandle time={text} format={'HH:mm:ss'} />
                </div>
              ),
            };
          }

          return {
            ...result,
            render: text => <span>{formatTextFloat(text)}</span>,
          };
        })}
      />
    </div>
  );
}
